// Export the Component Definition for use in Contentful Studio
export {IframeContentfulComponentDefinition} from './iframeContentfulDefinition';
export {default} from './Iframe';
